var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var CategoryTag = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display:flex;\n  gap:8px;\n"], ["\n  display:flex;\n  gap:8px;\n"])));
var templateObject_1;
